var React = require('react');

function DifficultyLevelBlueWhiteOutline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21 0H0V21H21V0Z","fill":"#4A90E2","key":0}),React.createElement("rect",{"x":"0.5","y":"0.5","width":"20","height":"20","stroke":"white","key":1})]);
}

DifficultyLevelBlueWhiteOutline.defaultProps = {"role":"presentation","viewBox":"0 0 21 21","fill":"none"};

module.exports = DifficultyLevelBlueWhiteOutline;

DifficultyLevelBlueWhiteOutline.default = DifficultyLevelBlueWhiteOutline;
